import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import Loader from "../Loader";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const Simpletrade = () => {
  const [tab, setTab] = useState(0);
  const [tradeTab, setTradeTab] = useState("activedata");
  const [tradeLoading, setTradeLoading] = useState(false);
  const [activeTrades, setActiveTrades] = useState([]);
  const [tradeHistory, setTradeHistory] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [cancelTradeId, setCancelTradeId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [pairs, setPairs] = useState([]);
  const [form, setForm] = useState({
    pair: "",
    order_type: "market",
    side: "buy",
    quantity: "",
    price: "",
    conditional_price: "",
    conditional_value: "",
    conditional_type: "",
    trailing_type: "",
    trailing_value: "",
    time_out: "",
    leverage: "",
  });
  const path = usercalls();

  const getPair = async () => {
    try {
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {
        market: state?.market_code || state?.market,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setPairs(result?.result || []);
      } else {
        setPairs([]);
      }
    } catch (err) {
      setPairs([]);
    }
  };

  useEffect(() => {
    if (!state?.market_code && !state?.market) return;
    getPair();
  }, [state?.market_code, state?.market]);

  useEffect(() => {
    if (!state?.id) {
      navigate("/botdashboard");
    }
  }, [state?.id, navigate]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const validate = (data) => {
    if (!state?.id) return "Account id missing";
    if (!data.pair) return "Pair is required";
    if (!data.order_type || !["market", "limit"].includes(data.order_type))
      return "Order type must be market or limit";
    if (!data.side || !["buy", "sell"].includes(data.side))
      return "Side must be buy or sell";
    if (!data.quantity || Number(data.quantity) <= 0)
      return "Quantity must be greater than 0";
    if (!data.price || Number(data.price) <= 0)
      return "Price is required and must be greater than 0";

    const total = Number(data.price) * Number(data.quantity || 0);
    if (!total || total <= 0)
      return "Total (price * quantity) must be greater than 0";
    if (total < 7.5) return "Total (price * quantity) must be at least 7.5";

    if (data.conditional_price && Number(data.conditional_price) <= 0)
      return "conditional_price must be greater than 0";
    if (
      data.conditional_price &&
      !["bid", "ask", "last"].includes(data.conditional_type)
    )
      return "conditional_type must be bid, ask, or last";
    if (
      data.conditional_price &&
      !["less_or_equal", "greater_or_equal"].includes(data.conditional_value)
    )
      return "conditional_value must be less_or_equal or greater_or_equal";
    if (
      data.trailing_type &&
      (!data.trailing_value || Number(data.trailing_value) <= 0)
    )
      return "trailing_value must be greater than 0";
    if (
      data.trailing_type &&
      !["value", "percent"].includes(data.trailing_type)
    )
      return "trailing_type must be value or percent";

    if (
      data.time_out &&
      (!Number.isInteger(Number(data.time_out)) || Number(data.time_out) <= 0)
    )
      return "time_out must be a positive integer";
    if (data.leverage && !["cross", "isolated"].includes(data.leverage))
      return "leverage must be cross or isolated";
    return null;
  };

  const handleSubmit = async () => {
    const err = validate(form);
    if (err) return toast.error(err);

    setSubmitLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/create-simple-trade`;
      const payload = {
        id: state.id,
        pair: form.pair,
        order_type: form.order_type,
        side: form.side,
        quantity: Number(form.quantity),
        price: Number(form.price),
      };

      // Include total for all order types
      const total = Number(form.price) * Number(form.quantity || 0);
      payload.total = Number(total.toFixed(12));

      if (form.conditional_price)
        payload.conditional_price = Number(form.conditional_price);
      if (form.conditional_value)
        payload.conditional_value = form.conditional_value;
      if (form.conditional_type)
        payload.conditional_type = form.conditional_type;
      if (form.trailing_type) payload.trailing_type = form.trailing_type;
      if (form.trailing_value)
        payload.trailing_value = Number(form.trailing_value);
      if (form.time_out) payload.time_out = Number(form.time_out);
      if (form.leverage) payload.leverage = form.leverage;

      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message || "Trade created successfully");
        setOpenTrade(false);
        // reset form
        setForm({
          pair: "",
          order_type: "market",
          side: "buy",
          quantity: "",
          price: "",
          conditional_price: "",
          conditional_value: "",
          conditional_type: "",
          trailing_type: "",
          trailing_value: "",
          time_out: "",
          leverage: "",
        });
        getTrades();
      } else {
        toast.error(result?.message || "Failed to create trade");
      }
    } catch (e) {
      console.error(e);
      toast.error("Cannot create trade");
    } finally {
      setSubmitLoading(false);
    }
  };

  const [openTrade, setOpenTrade] = useState(false);

  const getActiveTrades = async () => {
    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-simple-trade-details`;
      const payload = {
        id: state?.id,
        type: "active",
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        const items = Array.isArray(result.result)
          ? result.result
          : Array.isArray(result.data)
            ? result.data
            : Array.isArray(result)
              ? result
              : [];
        setActiveTrades(items);

        const total =
          typeof result.total === "number"
            ? result.total
            : typeof result.count === "number"
              ? result.count
              : result.meta?.total || items.length;
        setActiveTotal(Number(total || items.length));
      } else {
        setActiveTrades([]);
        setActiveTotal(0);
      }
      setTradeLoading(false);
    } catch (err) {
      setActiveTrades([]);
      setActiveTotal(0);
      setTradeLoading(false);
    }
  };

  const getHistoryTrades = async () => {
    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-simple-trade-details`;
      const payload = {
        id: state?.id,
        type: "history",
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        const items = Array.isArray(result.result)
          ? result.result
          : Array.isArray(result.data)
            ? result.data
            : Array.isArray(result)
              ? result
              : [];
        setTradeHistory(items);

        const total =
          typeof result.total === "number"
            ? result.total
            : typeof result.count === "number"
              ? result.count
              : result.meta?.total || items.length;
        setHistoryTotal(Number(total || items.length));
      } else {
        setTradeHistory([]);
        setHistoryTotal(0);
      }
      setTradeLoading(false);
    } catch (err) {
      setTradeHistory([]);
      setHistoryTotal(0);
      setTradeLoading(false);
    }
  };

  const getTrades = async () => {
    if (tab === 0) {
      getActiveTrades();
    } else {
      getHistoryTrades();
    }
  };

  const handleCancelTrade = async () => {
    if (!cancelTradeId) return;
    setCancelLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/cancel-simple-trade`;
      const payload = { uuid: cancelTradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message || "Trade cancelled successfully");
        setOpenConfirm(false);
        setCancelTradeId(null);
        getTrades();
      } else {
        toast.error(result?.message || "Failed to cancel trade");
      }
    } catch (e) {
      console.error(e);
      toast.error("Cannot cancel trade");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleEdit = (row) => {
    console.log("Edit clicked:", row);
    // open modal / navigate / update state
  };

  const handleConfirmCancel = (tradeUuid) => {
    setCancelTradeId(tradeUuid);
    setOpenConfirm(true);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeTotal, setActiveTotal] = useState(0);
  const [historyTotal, setHistoryTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // Refetch trades when tab, page or rowsPerPage changes
    getTrades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, page, rowsPerPage]);

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Toaster />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="bot_dash contain-width ">
            <div className="display-2">
              <h3 className="">Simple Trade</h3>
              <div className="bot_comman_btn">
                <Button onClick={() => setOpenTrade(true)}>Create Trade</Button>
              </div>
            </div>
          </div>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              {/* Tabs Header Styled Like Assets */}
              {/* <div className="h_flx flex-wrap gap-10">
                                <h3>Trades</h3>

                                <Tabs
                                    value={tab}
                                    onChange={(e, v) => setTab(v)}
                                    sx={{
                                        minHeight: "auto",
                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "#566FFF",
                                            height: "2px"
                                        }
                                    }}
                                >
                                    <Tab
                                        label="Active Trade"
                                        sx={{
                                            textTransform: "none",
                                            minHeight: "auto",
                                            fontWeight: 600
                                        }}
                                    />
                                    <Tab
                                        label="Trade History"
                                        sx={{
                                            textTransform: "none",
                                            minHeight: "auto",
                                            fontWeight: 600
                                        }}
                                    />
                               

                       
                                </Tabs>
                            </div> */}

              <div className=" display-1 flex-wrap gap-10">
                <h3
                  onClick={() => setTab(0)}
                  className={tab === 0 ? "active assetTab" : "assetTab"}
                >
                  Active Trade
                </h3>

                <h3
                  onClick={() => setTab(1)}
                  className={tab === 1 ? "active assetTab" : "assetTab"}
                >
                  Trade History
                </h3>
              </div>
              {tab === 0 && (
                <div className="custom_table box_bdr mt-20">
                  <div className="h_flx">
                    <h3>Active Trade</h3>
                  </div>

                  <TableContainer sx={{ marginBottom: "10px" }}>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>orderTime</TableCell>
                          <TableCell>Pairs</TableCell>
                          <TableCell>Order Type</TableCell>
                          <TableCell>Side</TableCell>
                          <TableCell>Order Price</TableCell>
                          <TableCell>StopLimit Price</TableCell>
                          <TableCell>Order Quantity</TableCell>
                          <TableCell>Order ID</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tradeLoading ? (
                          <TableRow>
                            <TableCell colSpan={10}>
                              <div className="inline-loader">
                                <Loader />
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : activeTrades?.length > 0 ? (
                          activeTrades.map((row, i) => (
                            <TableRow key={i} className="tr_row">
                              <TableCell>
                                {new Date(
                                  row.created_at * 1000,
                                ).toLocaleString()}
                              </TableCell>
                              <TableCell>{row.pair}</TableCell>
                              <TableCell>{row.order?.type || "-"}</TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.order?.side === "buy"
                                      ? "#00C853"
                                      : "#FF5252",
                                }}
                              >
                                {row.order?.side || "-"}
                              </TableCell>
                              <TableCell>{row.price?.value || "-"}</TableCell>
                              <TableCell>
                                {row.conditional?.enabled
                                  ? row.conditional?.price?.value || "-"
                                  : "-"}
                              </TableCell>
                              <TableCell>{row.units?.value || "-"}</TableCell>
                              <TableCell>{row.uuid?.slice(0, 8)}...</TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.status?.value?.toLowerCase() ===
                                    "failed"
                                      ? "#FF5252"
                                      : row.status?.value?.toLowerCase() ===
                                          "success"
                                        ? "#00C853"
                                        : "var(--clr-font)",
                                }}
                              >
                                {row.status?.value || "-"}
                              </TableCell>
                              <TableCell>
                                {row.data?.cancelable ? (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    color="error"
                                    onClick={() =>
                                      handleConfirmCancel(row.uuid)
                                    }
                                  >
                                    Cancel
                                  </Button>
                                ) : (
                                  <span style={{ fontSize: "12px" }}>—</span>
                                )}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              No Active Trades
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      component="div"
                      count={activeTotal || (activeTrades || []).length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </div>
              )}

              {tab === 1 && (
                <div className="custom_table box_bdr mt-20">
                  <div className="h_flx">
                    <h3>Trade History</h3>
                  </div>

                  <TableContainer sx={{ marginBottom: "10px" }}>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Order Time</TableCell>
                          <TableCell>Pair</TableCell>
                          <TableCell>Order Type</TableCell>
                          <TableCell>Side</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Total</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Filled Units</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tradeLoading ? (
                          <TableRow>
                            <TableCell colSpan={8}>
                              <div className="inline-loader">
                                <Loader />
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : tradeHistory?.length > 0 ? (
                          tradeHistory.map((row, i) => (
                            <TableRow key={i} className="tr_row">
                              <TableCell>
                                {new Date(
                                  (row.closed_at || row.created_at) * 1000,
                                ).toLocaleString()}
                              </TableCell>
                              <TableCell>{row.pair}</TableCell>
                              <TableCell>{row.order?.type || "-"}</TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.order?.side === "buy"
                                      ? "#00C853"
                                      : "#FF5252",
                                }}
                              >
                                {row.order?.side || "-"}
                              </TableCell>
                              <TableCell>{row.units?.value || "-"}</TableCell>
                              <TableCell>{row.price?.value ?? "-"}</TableCell>
                              <TableCell>{row.total?.value ?? "-"}</TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.status?.value?.toLowerCase() ===
                                    "failed"
                                      ? "#FF5252"
                                      : row.status?.value?.toLowerCase() ===
                                          "success"
                                        ? "#00C853"
                                        : "var(--clr-font)",
                                }}
                              >
                                {row.status?.value || "-"}
                              </TableCell>
                              <TableCell>{row.filled?.units ?? "-"}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No Trade History
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      component="div"
                      count={historyTotal || (tradeHistory || []).length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </div>
              )}
            </div>
          </div>

          {/* <Grid item xs={12}>
                        <div className="custom_table box_bdr">

                            <div className="h_flx flex-wrap gap-10">
                                <h3>Trades</h3>

                                <h3
                                    onClick={() => setTradeTab("active")}
                                    className={tradeTab === "active" ? "active assetTab" : "assetTab"}
                                >
                                    Active Trade
                                </h3>

                                <h3
                                    onClick={() => setTradeTab("history")}
                                    className={tradeTab === "history" ? "active assetTab" : "assetTab"}
                                >
                                    Trade History
                                </h3>
                            </div>

                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Order Time</TableCell>
                                            <TableCell>Pair</TableCell>
                                            <TableCell>Order Type</TableCell>
                                            <TableCell>Slide</TableCell>
                                            {tradeTab === "active" && (
                                                <TableCell>Order Price</TableCell>
                                            )}

                                            {tradeTab === "history" && (
                                                <TableCell>Filled Price</TableCell>
                                            )}
                                            <TableCell>Status</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {(tradeTab === "active"
                                            ? activeTradeData
                                            : tradeHistoryData
                                        )?.map((row, index) => (
                                            <TableRow key={index}>

                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{row.orderTime}</TableCell>
                                                <TableCell>{row.pair}</TableCell>
                                                <TableCell>{row.orderType}</TableCell>
                                                <TableCell>{row.side}</TableCell>

                                                {tradeTab === "active" && (
                                                    <TableCell>{row.orderPrice}</TableCell>
                                                )}

                                                {tradeTab === "history" && (
                                                    <TableCell>{row.filledPrice}</TableCell>
                                                )}

                                                <TableCell>{row.status}</TableCell>

                                                <TableCell align="center">
                                                    {tradeTab === "active" ? "Cancel" : "View"}
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </Grid> */}
        </Grid>
      </Grid>

      <Modal
        open={openTrade}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Create Trade</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => setOpenTrade(false)}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            {pairs && pairs.length > 0 ? (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pair (required)</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pair"
                  value={form.pair}
                  onChange={handleFormChange}
                  labelId="pair-label"
                  id="pair"
                  label="Pair (required)"
                  required
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  {pairs.map((p, idx) => {
                    const label =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.label;
                    const value =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.value;
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : (
              <TextField
                label="Pair (required)"
                name="pair"
                fullWidth
                className="bot-input"
                value={form.pair}
                onChange={handleFormChange}
                required
              />
            )}

            <FormControl fullWidth required>
              <InputLabel id="order-type-label">
                Order Type (required)
              </InputLabel>
              <Select
                className="bot-select"
                name="order_type"
                value={form.order_type}
                onChange={handleFormChange}
                labelId="order-type-label"
                id="order_type"
                label="Order Type (required)"
                required
              >
                <MenuItem value="market">market</MenuItem>
                <MenuItem value="limit">limit</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth required>
              <InputLabel id="side-label">Side (required)</InputLabel>
              <Select
                className="bot-select"
                name="side"
                value={form.side}
                onChange={handleFormChange}
                labelId="side-label"
                id="side"
                label="Side (required)"
                required
              >
                <MenuItem value="buy">buy</MenuItem>
                <MenuItem value="sell">sell</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Quantity (required)"
              name="quantity"
              type="number"
              fullWidth
              className="bot-input"
              value={form.quantity}
              onChange={handleFormChange}
              required
            />

            <TextField
              label="Price (required)"
              name="price"
              type="number"
              fullWidth
              className="bot-input"
              value={form.price}
              onChange={handleFormChange}
              required
            />

            <TextField
              label="Conditional Price (optional)"
              name="conditional_price"
              type="number"
              fullWidth
              className="bot-input"
              value={form.conditional_price}
              onChange={handleFormChange}
            />

            <FormControl fullWidth>
              <InputLabel id="conditional-value-label">
                Conditional Value (optional)
              </InputLabel>
              <Select
                className="bot-select"
                name="conditional_value"
                value={form.conditional_value}
                onChange={handleFormChange}
                labelId="conditional-value-label"
                id="conditional_value"
                label="Conditional Value (optional)"
              >
                <MenuItem value="">Conditional Value</MenuItem>
                <MenuItem value="less_or_equal">less_or_equal</MenuItem>
                <MenuItem value="greater_or_equal">greater_or_equal</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="trailing-type-label">
                Trailing Type (optional)
              </InputLabel>
              <Select
                className="bot-select"
                name="trailing_type"
                value={form.trailing_type}
                onChange={handleFormChange}
                labelId="trailing-type-label"
                id="trailing_type"
                label="Trailing Type (optional)"
              >
                <MenuItem value="">Trailing Type</MenuItem>
                <MenuItem value="value">value</MenuItem>
                <MenuItem value="percent">percent</MenuItem>
              </Select>
            </FormControl>

            {form.trailing_type && (
              <TextField
                label="Trailing Value"
                name="trailing_value"
                type="number"
                fullWidth
                className="bot-input"
                value={form.trailing_value}
                onChange={handleFormChange}
              />
            )}

            <FormControl fullWidth>
              <InputLabel id="conditional-type-label">
                Conditional Type
              </InputLabel>
              <Select
                className="bot-select"
                name="conditional_type"
                value={form.conditional_type}
                onChange={handleFormChange}
                labelId="conditional-type-label"
                id="conditional_type"
                label="Conditional Type"
              >
                <MenuItem value="">Conditional Type</MenuItem>
                <MenuItem value="ask">ask</MenuItem>
                <MenuItem value="bid">bid</MenuItem>
                <MenuItem value="last">last</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="timeout-label">Timeout</InputLabel>
              <Select
                className="bot-select"
                name="time_out"
                value={form.time_out}
                onChange={handleFormChange}
                labelId="timeout-label"
                id="time_out"
                label="Timeout"
              >
                <MenuItem value="">Select Time</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={15}>15</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="leverage-label">Leverage</InputLabel>
              <Select
                className="bot-select"
                name="leverage"
                value={form.leverage}
                onChange={handleFormChange}
                labelId="leverage-label"
                id="leverage"
                label="Leverage"
              >
                <MenuItem value="">Leverage</MenuItem>
                <MenuItem value="cross">Cross</MenuItem>
                <MenuItem value="isolated">Isolated</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={style}>
          <div className="p-20">
            Are you sure you want to cancel this trade?
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenConfirm(false);
                  setCancelTradeId(null);
                }}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCancelTrade}
                disabled={cancelLoading}
              >
                {cancelLoading ? "Cancelling..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Simpletrade;
